/**
 * store/modules/admin/adminUser.js
 *
 * Vuex module handling admin user controller state and actions.
 */
import axios from 'axios'

export default {
  // Admin User state.
  state: {
    adminUserSearchResults: [],
    adminUserView: {},
    adminUserViewCurrentInvestments: [],
    adminUserViewPastInvestments: [],
    adminUserViewTransactionHistory: []
  },

  // Mutations to alter admin user results.
  mutations: {
    setAdminUserResults: (state, results) => (state.adminUserSearchResults = results),
    setAdminUserView: (state, result) => (state.adminUserView = result),
    setAdminUserViewCurrentInvestments: (state, result) => (state.adminUserViewCurrentInvestments = result),
    setAdminUserViewPastInvestments: (state, result) => (state.adminUserViewPastInvestments = result),
    setAdminUserViewTransactionHistory: (state, result) => (state.adminUserViewTransactionHistory = result)
  },

  // Actions handling requests, and committing mutations.
  actions: {
    // Search users.
    async userSearch ({ commit }, query = '') {
      try {
        let response = await axios.get('/api/admin/user', {
          params: { q: query }
        })
        commit('setAdminUserResults', response.data)
      } catch (error) {
        console.error('Unable to search users.')
      }
    },

    // Get User by Id
    async getUserById ({commit}, userId) {
      try {
        let response = await axios.get(`/api/admin/user/${userId}`)
        commit('setAdminUserView', response.data)
      } catch (error) {
        console.error(`unable to fetch user ${userId}`)
        console.error(error)
      }
    },

    // Admin add funds to a users wallet.
    async updateUserWallet (context, { userId, amount }) {
      try {
        await axios.put(`/api/admin/user/${userId}/wallet/${amount}`)
      } catch (error) {
        console.error(`Unable to add $${amount} to user ${userId}!`)
        throw(error)
      }
    },

    // Get Current Investments
    async adminGetCurrentInvestments ({commit}, userId) {
      try {
        let response = await axios.get(`/api/admin/flip-ui/user/${userId}/current-investments`)
        commit('setAdminUserViewCurrentInvestments', response.data)
      } catch (error) {
        console.error(`unable to fetch current investments for user ${userId}`)
        console.error(error)
      }
    },

    // Get Past Investments
    async adminGetPastInvestments ({commit}, userId) {
      try {
        let response = await axios.get(`/api/admin/flip-ui/user/${userId}/past-investments`)
        commit('setAdminUserViewPastInvestments', response.data)
      } catch (error) {
        console.error(`unable to fetch past investments for user ${userId}`)
        console.error(error)
      }
    },

    // Get Transaction History
    async adminGetTransactionHistory ({commit}, userId) {
      /*
      try {
        let response = await axios.get(`/api/admin/flip-ui/user/${userId}/transaction-history`)
        commit('setAdminUserViewTransactionHistory', response.data)
      } catch (error) {
        console.error(`unable to fetch transaction history for user ${userId}`)
        console.error(error)
      }
      */
      try {
        let endpoints = [
          //`/api/admin/flip-ui/user/${userId}/transaction-history?actionType=ALL`,
          `/api/admin/flip-ui/user/${userId}/transaction-history?actionType=OUTSIDE`,
          `/api/admin/flip-ui/user/${userId}/transaction-history?actionType=FEES`,
          `/api/admin/flip-ui/user/${userId}/transaction-history?actionType=PURCHASES`
        ];
        let response = await Promise.all(endpoints.map((endpoint) => axios.get(endpoint))).then(
          //axios.spread(({data:all}, {data:outside}, {data:fees}, {data:purchases}) => {
            axios.spread(({data:outside}, {data:fees}, {data:purchases}) => {
            //console.log({ all, outside, fees, purchases });

            response = {
              //all: all,
              outside: outside,
              fees: fees,
              purchases: purchases,
            }
            commit('setAdminUserViewTransactionHistory', response)
          })
        );
      } catch (error) {
        console.error(`unable to fetch transaction history for user ${userId}`)
        console.error(error)
      }
    }
  },

  // Admin User state getters.
  getters: {
    adminUserSearchResults: state => state.adminUserSearchResults,
    adminUserView: state => state.adminUserView,
    adminUserViewCurrentInvestments: state => state.adminUserViewCurrentInvestments,
    adminUserViewPastInvestments: state => state.adminUserViewPastInvestments,
    adminUserViewTransactionHistory: state => state.adminUserViewTransactionHistory
  }
}
